var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"slot"},[_vm._t("default")],2),(!_vm.isEmptyData)?_c('pre',{staticClass:"code ml-8"},[_vm._v(_vm._s(_vm.propData))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }